/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bench_OptoutInputs */

const en_fw_bench_optout = /** @type {(inputs: Fw_Bench_OptoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exclude my data from the public benchmark`)
};

const id_fw_bench_optout = /** @type {(inputs: Fw_Bench_OptoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kecualikan datamu dari benchmark publik`)
};

/**
* | output |
* | --- |
* | "Exclude my data from the public benchmark" |
*
* @param {Fw_Bench_OptoutInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bench_optout = /** @type {((inputs?: Fw_Bench_OptoutInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bench_OptoutInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bench_optout(inputs)
	return en_fw_bench_optout(inputs)
});